export default "__VITE_ASSET__BSpc0wKL__"